import { usePostHog } from 'posthog-js/react';
import { useEffect, useRef } from 'react';
import { useEstateBaseInfo } from '@/features/estates-property/api/estate';

export function useTrackEstateView(estateId: string) {
  const { data } = useEstateBaseInfo({ id: estateId });
  const posthog = usePostHog();

  const trackingRef = useRef({ startTime: Date.now() });

  useEffect(() => {
    return () => {
      if (!data) return;
      const duration = Date.now() - trackingRef.current.startTime;

      if (duration > 1000) {
        posthog?.capture('estate_view', {
          estate_id: data.id,
          tenant_id: data.tenantId,
          project_id: data.projectId,
          duration_in_ms: duration,
          duration_in_seconds: Math.round(duration / 1000),
          duration_in_minutes: Math.round(duration / 60_000),
        });
      }
    };
  }, [data, posthog]);
}
